import { IItemByValue } from '../pages/Dashboard/ItemByValueDashboardChart';
import { IInventoryReportType } from '../sp-types/InventoryReportType';
import { DEFAULT_COLOR, IInventoryProduct } from '../sp-types/InventoryType';
import { Material } from '../sp-types/materialType';
import { dateToMonthYear, sortMonthYear } from './MonthYear/monthYear';

export const getLastMaterialDate = (pastProducts: IInventoryProduct[]): IInventoryProduct => {
  const sortedPrducts = pastProducts.sort((a, b) => sortMonthYear(a.date, b.date));

  return sortedPrducts[sortedPrducts.length];
};

export const groupByMaterial = (inventoryReports: IInventoryReportType[]): Record<string, IInventoryReportType[]> =>
  inventoryReports.reduce(
    (acc, material) => ({ ...acc, [material.materialId]: [...acc[material.materialId], material] }),
    {} as Record<string, IInventoryReportType[]>,
  );

export const sumInvReports = (
  inventoryReports: IInventoryReportType[],
  pricesMap: Record<string, number>,
  getCurrencyInUSD: (_currency: string) => number,
): Record<string, { quantity: number; actualPriceSum: number }> =>
  inventoryReports
    .filter(({ ratio, dontSum }) => (!ratio || ratio === 0) && !dontSum)
    .reduce((acc, { materialId, actualPrice, quantity, currency, suppliedQty }) => {
      const remainingQuantity = quantity < suppliedQty ? 0 : (quantity || 0) - (suppliedQty || 0);
      return {
        ...acc,
        [materialId]: {
          quantity: (acc[materialId]?.quantity || 0) + remainingQuantity,
          actualPriceSum:
            (acc[materialId]?.actualPriceSum || 0) +
            ((actualPrice || 0) * getCurrencyInUSD(currency || '') || pricesMap[materialId]) * remainingQuantity,
        },
      };
    }, {} as Record<string, { quantity: number; actualPriceSum: number }>);

export const fixMonthYear = (material: IInventoryReportType): IInventoryReportType => {
  material.monthYear = dateToMonthYear(material.reportingTime.toDate());
  return material;
};

export const getItemByValueData = (
  inventoryReports: IInventoryReportType[],
  materialMap: Record<string, Material>,
  pricesMap: Record<string, number>,
  colorDictionary: Record<string, string>,
): IItemByValue[] => {
  const lastMaterialReports = groupByMaterial(inventoryReports);

  return Object.values(lastMaterialReports)
    .map((a) => a[0]) // this is quick fix. the sceen wont work
    .map(({ materialId, quantity }) => ({
      color: colorDictionary[materialId] || DEFAULT_COLOR,
      item: materialMap[materialId]?.name || materialId,
      value: pricesMap[materialId] * quantity,
    }));
};
